const types = {
  SET_IS_LOADING: 'app-loading-feature.set-is-loading',
}

const start = () => ({ type: types.SET_IS_LOADING, payload: true })

const finish = () => ({ type: types.SET_IS_LOADING, payload: false })

const appLoadingFeatureActions = {
  types,
  start,
  finish,
}

export default appLoadingFeatureActions
